export const WHATSAPP_NUMBER = "5511971122554";
export const WHATSAPP_DEFAULT_MSG = "Olá, vim pelo site e gostaria de agendar um horário";

export const whatsappLink = (msg = WHATSAPP_DEFAULT_MSG) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(msg)}`;

// Link to a client's own WhatsApp (adds Brazil country code when missing).
export const clientWhatsappLink = (phone, msg) => {
  const digits = String(phone || "").replace(/\D/g, "");
  const intl = digits.length <= 11 ? `55${digits}` : digits;
  return `https://wa.me/${intl}?text=${encodeURIComponent(msg)}`;
};

export const SALON_NAME = "EZ Capelli Studio";
